import { render } from "./MaterialsBooks.vue?vue&type=template&id=a5b03456&scoped=true"
import script from "./MaterialsBooks.vue?vue&type=script&lang=js"
export * from "./MaterialsBooks.vue?vue&type=script&lang=js"

import "./MaterialsBooks.vue?vue&type=style&index=0&id=a5b03456&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5b03456"]])

export default __exports__